import Vue from 'vue'
import { AclInstaller, AclCreate, AclRule } from 'vue-acl'
import router from '@/router'

Vue.use(AclInstaller)

let initialRole = 'public'

localStorage.getItem('eduRole') ? initialRole = localStorage.getItem('eduRole'): initialRole = 'public'

export default new AclCreate({
  initial: initialRole,
  notfound: '/pages/not-authorized',
  router,
  acceptLocalRules: true,
  globalRules: {
    admin: new AclRule('admin').generate(),
    teacher: new AclRule('teacher').or('admin').generate(),
    student: new AclRule('student').or('teacher').or('admin').generate(),
    public: new AclRule('public').or('student').or('teacher').or('admin').generate(),
  }
})
